












import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import BGMSound from "@/media/BGMSound";
import { WindowVisibilityChecker, WindowVisibilityEvent } from "@/libs/WindowVisibilityChecker";
import { AppEvent } from "@/events/AppEvent";

@Component({
  computed: mapState('bgm', [ 'isBgmMuted', 'isBgmPlaying'])
})
export default class BgmController extends Vue {
  // mapState: isBgmMuted
  private isBgmMuted: boolean;
  // mapState: isBgmPlaying
  private isBgmPlaying: boolean;
  // loading flag
  private isBgmLoading: boolean;
  // sound
  private sound: BGMSound;

  private windowVisibility: WindowVisibilityChecker;


  // スマートフォンレイアウトフラグ
  get isSmp (): boolean {
    return this.$store.state.isSmp;
  }

  @Watch('isBgmPlaying')
  onChangePlaying (newValue, oldValue): void {
    if (newValue !== oldValue) {
      if (newValue) {
        this.playBgm(true);
        if (!this.windowVisibility) {
          this.windowVisibility = new WindowVisibilityChecker();
          this.windowVisibility.enableCheck();
        }
        this.windowVisibility.addEventListener(WindowVisibilityEvent.HIDDEN, this.onWindowHide);
        this.windowVisibility.addEventListener(WindowVisibilityEvent.VISIBLE, this.onWindowVisible);
      }
      else {
        this.pauseBgm(true);
        this.windowVisibility.removeAllEventListeners();
      }
    }
  }


  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(async () => {
      const bgmUrl: string = this.$store.state.publicPath + this.$store.state.bgm.bgmUrl;
      this.sound = new BGMSound(bgmUrl, 0.2);
      this.sound.addEventListener(AppEvent.LOAD_COMPLETE, this.onLoadComplete);
      this.isBgmLoading = true;
      this.sound.load();
    });
  }


  protected onLoadComplete (ev: Event): void {
    this.sound.removeAllEventListeners();
    this.$emit(AppEvent.LOAD_COMPLETE);
    this.isBgmLoading = false;
    console.log('BGM LoadComplete');
  }


  /**
   * BGMの再生
   */
  public playBgm (fade: boolean = false): void {
    console.log('Play Bgm');
    this.sound.play(fade);
  }

  public pauseBgm (fade: boolean = false): void {
    console.log('Pause Bgm');
    this.sound.pause(fade);
  }


  // BGMオン・オフのフラグ
  private onToggleBgm (ev: MouseEvent): void {
    if (this.isBgmMuted) {
      this.$store.commit('bgm/toggleBgm', { toggle: true });
    }
    else {
      this.$store.commit('bgm/toggleBgm', { toggle: false });
    }
  }

  /**
   * ウィンドウ（タブ）が非アクティブ状態になった時
   * @param ev
   */
  protected onWindowHide (ev: WindowVisibilityEvent): void {
    console.log('Windowが非アクティブになった');
    if (this.isBgmPlaying) {
      this.pauseBgm();
    }
  }

  /**
   * ウィンドウ（タブ）がアクティブ状態になった時
   * @param ev
   */
  protected onWindowVisible (ev: WindowVisibilityEvent): void {
    console.log('Windowがアクティブになった');
    if (this.isBgmPlaying) {
      this.playBgm();
    }
  }

}
